import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
   // styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    constructor(public router: Router) { }

    ngOnInit() {
        let body = document.getElementsByTagName('body')[0];
   body.classList.remove("zizbackground");
      body.classList.remove("overflow");
      let section = document.getElementsByTagName('section')[0];
section.onclick = function(){
     var x= document.getElementById('id3');
       x.classList.remove("submenuActiveAdmin"); 
}

let sidebar = <HTMLInputElement>(document.getElementsByClassName('sidebar'))[0];
sidebar.onclick = function(){
     var x= document.getElementById('id3');
       x.classList.remove("submenuActiveAdmin"); 

    }

     var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 


}
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/layout.component.ts